module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/document-7b9f8a0c931a618b24e532fc35c402ce.svg";